import React from 'react';
import { ArrowRightIcon, UsersIcon } from 'lucide-react';
import { audience, differentiators } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Audience() {
  return <section className="w-full bg-sand px-4 py-14 sm:px-6 sm:py-20" data-id="element-58" data-mp="1dxgntxcc6ssj">
      <div className="mx-auto max-w-3xl" data-id="element-59" data-mp="1hy8xgrp4ezpc">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-60" data-mp="1hzak7tfi1amw">A chi è rivolto</p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy sm:text-4xl" data-id="element-61" data-mp="25od0awuhivfa">
          Creato per i professionisti che pianificano i propri casi
        </h2>

        <div className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-62" data-mp="1wmn9nt8fg0ik">
          {audience.map(item => <article key={item.title} className="flex flex-col rounded-2xl bg-white p-5" data-id="element-63" data-mp="21kx9wi90drb1">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-navy-tint" data-id="element-64" data-mp="l770cvz4eau0">
                <UsersIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-65" data-mp="q7uq7ebm4lmn" />
              </span>
              <h3 className="mt-3 font-display text-[17px] font-bold leading-snug text-navy" data-id="element-66" data-mp="zn2ybaholyhi">{item.title}</h3>
              <p className="mt-1.5 text-[13.5px] leading-relaxed text-navy/65" data-id="element-67" data-mp="uorov0vatpzt">{item.body}</p>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-68" data-mp="14le7rk42e6z7">
          <h2 className="text-center font-display text-[24px] font-bold leading-tight text-navy sm:text-3xl" data-id="element-69" data-mp="14l4qckx35854">
            Cosa rende questo Sistema diverso?
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-center text-[15px] leading-relaxed text-navy/70" data-id="element-70" data-mp="1dmceia5w0slh">
            È costruito attorno alle decisioni, non solo alle informazioni.
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-71" data-mp="1nbvxrgxiiogv">
            <div className="rounded-2xl border border-navy/10 bg-white/60 p-5" data-id="element-72" data-mp="1nce1szqf26zc">
              <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-navy/40" data-id="element-73" data-mp="21coum8badvn5">Invece di</p>
              <p className="mt-2 font-display text-[16px] italic leading-snug text-navy/60" data-id="element-74" data-mp="1xbd1hst7esa7">
                “Ecco tutto quello che devi sapere sugli allineatori.”
              </p>
            </div>
            <div className="rounded-2xl border-2 border-brand bg-white p-5" data-id="element-75" data-mp="29d4lolf9k094">
              <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.16em] text-brand-dark" data-id="element-76" data-mp="2eb64d58s1xk2">
                Troverai <ArrowRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-77" data-mp="2j3pgdxrtgkmr" />
              </p>
              <p className="mt-2 font-display text-[16px] font-bold italic leading-snug text-navy" data-id="element-78" data-mp="2n2yc386f2sky">
                “Ecco cosa devi valutare prima di prendere questa decisione.”
              </p>
            </div>
          </div>

          <p className="mt-6 text-center text-[14.5px] leading-relaxed text-navy/70" data-id="element-79" data-mp="2wzukzf089gq1">
            Non hai bisogno di un altro corso di 8 ore. Hai bisogno di risorse a cui poter tornare mentre stai
            realmente pianificando un caso. Per questo il Sistema include:
          </p>

          <ul className="mt-5 space-y-2.5" data-id="element-80" data-mp="17n9bgydw1me5">
            {differentiators.map(item => <li key={item.title} className="rounded-2xl bg-white px-4 py-3.5" data-id="element-81" data-mp="3kytvfxnesx1l">
                <p className="font-display text-[15.5px] font-bold text-navy" data-id="element-82" data-mp="3g5hi4jo6kco5">{item.title}</p>
                <p className="mt-0.5 text-[13.5px] leading-relaxed text-navy/65" data-id="element-83" data-mp="3c60cnq8r7fiz">{item.body}</p>
              </li>)}
          </ul>
        </div>

        <CtaBlock className="mt-9" label="Sì, è esattamente ciò che mi serve" data-id="element-84" data-mp="7qqtaeyzx7o2" />
      </div>
    </section>;
}